import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TicketPriority } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-priority.enum';
import { CreateTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/inputs/create-ticket.model';
import { ControllerRenderProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PriorityPopoverComponent } from './priority-popover.component';

export const PrioritySelectionComponent = ({
  field,
}: {
  field: ControllerRenderProps<CreateTicketModel, 'priority'>;
}): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack direction="column">
      <Text uppercase fontSize={TextFontSize.Small}>
        {t('delmonicos-shared-sdk.inputs-create-ticket.priority')}
      </Text>
      <PriorityPopoverComponent
        priority={field.value ?? TicketPriority.Normal}
        onSelect={field.onChange}
      />
    </Stack>
  );
};
